module.exports = __webpack_public_path__ + "static/media/alex.cc921651.jpg";